const axios = require('axios');

class Vapor {
    /**
     * Store a file in S3 and return its UUID, key, and other information.
     */
    async store(file, options = {}) {
        const response = await axios.post('/vapor/signed-storage-url', {
            bucket: options.bucket || '',
            content_type: options.contentType || file.type,
            expires: options.expires || '',
            visibility: options.visibility || '',
        }, {
            baseURL: options.baseURL || null, headers: options.headers || {},
        });

        let headers = response.data.headers;

        if ('Host' in headers) {
            delete headers.Host;
        }

        if (typeof options.progress === 'undefined') {
            options.progress = () => {
            };
        }

        const cancelToken = options.cancelToken || '';

        const s3Response = await axios.put(response.data.url, file, {
            cancelToken: cancelToken, headers: headers, onUploadProgress: (progressEvent) => {
                options.progress(progressEvent.loaded / progressEvent.total);
            },
        });

        response.data.etag = _.get(s3Response, 'headers.etag', '').replace(/['"]+/g, '');
        response.data.extension = file.name.split('.').pop();

        return response.data;
    }
}

export default new Vapor();
